import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { enUS, zhCN } from "date-fns/locale";
import type { Locale } from "date-fns";

// Maps the active i18n language to a date-fns locale for react-datepicker.
// `en-XA` is the pseudo-locale: the calendar's month/weekday text comes from
// date-fns (not our JSON bundle) so there is nothing to pseudo-localize — fall
// back to enUS. There is no date-fns `zh-Hans` locale; Simplified Chinese uses
// `zh-CN`.
const LOCALE_BY_LANG: Record<string, Locale> = {
  en: enUS,
  "en-XA": enUS,
  "zh-Hans": zhCN,
};

export function useDatepickerLocale(): Locale {
  const { i18n } = useTranslation();
  return useMemo(() => {
    const lng = i18n.language;
    return LOCALE_BY_LANG[lng] ?? LOCALE_BY_LANG[lng.split("-")[0] ?? lng] ?? enUS;
  }, [i18n.language]);
}
